export default __webpack_public_path__ + "static/media/t_wdt_c_0.89ce889b.mp3";